const appConfig = {
  appName: "Intelligent Virtual Assistant (IVA)",
  subTitle: "for Government Services",
  companyName: "BDO",
  workspaceName: "IVA Workspace",
  loginDescription:
      "Intelligent Virtual Assistant (IVA) delivers AI-powered insights and tools to drive smarter, faster business decisions.",
  loginSubtitle:
      "Secure sign-in powered by your organization’s identity provider.",
  loginFooter: "You’ll be redirected to Microsoft to complete sign-in.",
  mainLoginPage:
      "https://react-poc-cache-fca0ffhpbjf0e6du.eastus2-01.azurewebsites.net/",
};

export default appConfig;
